import React from 'react';

export const PageHeader = ({ title, description, actions, eyebrow }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 border-b border-white/5 pb-5">
    <div className="min-w-0">
      {eyebrow && <div className="text-[11px] uppercase tracking-[0.12em] text-[hsl(var(--text-3))]">{eyebrow}</div>}
      <h1 className="mt-1 text-xl font-semibold tracking-tight" data-testid="page-header-title">{title}</h1>
      {description && (
        typeof description === 'string'
          ? <p className="mt-1 text-sm text-[hsl(var(--text-3))]">{description}</p>
          : <div className="mt-1 text-sm text-[hsl(var(--text-3))]">{description}</div>
      )}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
